package info.rezident.app.pages

import androidx.compose.runtime.*
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.grayscale
import com.varabyte.kobweb.compose.dom.disposableRef
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.GeneralKind
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import info.rezident.app.MaxWidthStyle
import info.rezident.app.core.AnimationPlaybackControls
import info.rezident.app.core.AppTracking
import info.rezident.app.core.animate
import info.rezident.app.core.scroll
import info.rezident.app.data.quiz.RecommendationItem
import info.rezident.app.seo.*
import info.rezident.app.ui.components.animations.*
import info.rezident.app.ui.components.sections.FiveScaleSlider
import info.rezident.app.ui.components.sections.NavHeader
import info.rezident.app.ui.components.widgets.NumberCircle
import info.rezident.app.ui.components.widgets.ProConsList
import info.rezident.app.ui.components.widgets.RecommendationCardContent
import info.rezident.app.ui.components.widgets.Spacer
import info.rezident.app.ui.theme.AppTheme
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLElement
import org.w3c.dom.events.Event
import org.w3c.dom.pointerevents.PointerEvent
import kotlin.js.json
import kotlin.math.ceil

@Page("index")
@Composable
fun Landing() {
    AutoScrollHandler()

    val title = "Ce Specialitate Aleg la Rezidentiat 2026"
    val description =
        "Completează Quiz-ul de Orientare pentru Rezi și primești Recomandări Personalizate de Specialități, cu Scor de Potrivire, Puncte Forte/Slabe și Analiză Detaliată."
    val canonicalUrl = "https://rezident.info/"
    val ogTitle = "Ce Specialitate Aleg la Rezidentiat 2026"
    val ogImageUrl = "https://rezident.info/assets/og/og-image.png"

    Seo(title = title, description = description)

    LaunchedEffect(Unit) {
        document.setCanonicalUrl(canonicalUrl)
        document.setMetaNameTag(name = "robots", content = "index, follow")
        document.setMetaNameTag(name = "twitter:card", content = "summary_large_image")
        document.setMetaNameTag(name = "twitter:title", content = title)
        document.setMetaNameTag(name = "twitter:description", content = description)
        document.setMetaNameTag(name = "twitter:image", content = ogImageUrl)

        document.setOpenGraphTag(property = "og:title", content = ogTitle)
        document.setOpenGraphTag(property = "og:description", content = description)
        document.setOpenGraphTag(property = "og:url", content = canonicalUrl)
        document.setOpenGraphTag(property = "og:image", content = ogImageUrl)
    }

    val homeJsonLd: String = """
        {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Organization",
              "@id": "https://rezident.info/#org",
              "name": "rezident.info",
              "url": "https://rezident.info/",
              "logo": "https://rezident.info/logo-light.png",
              "sameAs": [
                "https://www.instagram.com/rezident.info"
              ]
            },
            {
              "@type": "WebSite",
              "@id": "https://rezident.info/#website",
              "url": "https://rezident.info/",
              "name": "Ce Specialitate Aleg la Rezidentiat 2026",
              "inLanguage": "ro-RO",
              "publisher": {
                "@id": "https://rezident.info/#org"
              }
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://rezident.info/#breadcrumb",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Acasă",
                  "item": "https://rezident.info/"
                }
              ]
            },
            {
              "@type": "FAQPage",
              "@id": "https://rezident.info/#faq",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "Ce este Quiz-ul de Orientare?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Este un instrument de autocunoaștere, nu un test. Răspunzi la întrebări despre personalitatea și preferințele tale, și afli ce specialități medicale se potrivesc cel mai bine cu criteriile pe care ți le dorești."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Cum funcționează? Îmi \"ghicește\" specialitatea potrivită?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Nu ghicim. Platforma compară profilul tău, creat pe baza răspunsurilor tale, cu profilul \"ideal\" al fiecărei specialități (ex. Cardiologia necesită rezistență ridicată la stres). Algoritmul nostru calculează cât de bine se potrivesc aceste două profiluri."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Cât de precise sunt rezultatele?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Precizia rezultatelor depinde de două lucruri, onestitatea ta și datele noastre - cu cât răspunzi mai sincer, cu atât profilul tău va fi mai corect. Profilurile specialităților nu sunt bazate pe opinii subiective. Acestea au fost meticulos construite folosind informații din ghidurile oficiale de rezidențiat, fișele de specialitate și descrierile profesionale ale mediilor de lucru."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Rezultatul îmi va spune exact ce specialitate să aleg?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Nu. Gândește-te la Quiz-ul de Orientare ca la o busolă. Rolul lui este să îți arate o direcție. Îți poate valida alegerile pe care le luai deja în considerare sau, și mai important, îți poate evidenția specialități la care poate nu te-ai fi gândit niciodată, dar care se potrivesc surprinzător de bine cu profilul tău."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Ce voi primi la finalul Quiz-ului?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Vei primi un clasament personalizat al tuturor specialităților, sortate de la cea mai mică la cea mai mare potrivire, cu un scor procentual (ex. 95%). Funcția de Analiză Detaliată îți arată de ce ți se potrivește. Puncte Forte: Profilul tău se aliniază exact cu cerințele (de ex., \"Tu ai spus că iubești adrenalina, iar Medicina de Urgență exact asta cere.\").\n Puncte Slabe: Preferințele tale diferă de cerințe (de ex., \"Tu prețuiești enorm echilibrul muncă-viață, dar Chirurgia Cardiovasculară implică multe gărzi.\")."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Cât durează Quiz-ul?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Câteva minute. Îți recomandăm să nu te grăbești și să răspunzi cât mai sincer pentru a obține cel mai relevant rezultat."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Pot repeta Quiz-ul?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Poți repeta Quiz-ul de Orientare de câte ori dorești, în caz că vrei să încerci răspunsuri diferite."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Quiz-ul de Orientare este gratuit?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Scopul rezident.info este să ajute cât mai mulți studenți să se informeze. Quiz-ul de Orientare și Recomandările sunt gratis. Funcția de Analiza Detaliată are un cost simbolic, pentru cei entuziasmați."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Datele mele sunt în siguranță?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Da. Răspunsurile tale sunt criptate, folosite doar pentru algoritmul de potrivire și nu sunt partajate cu terți."
                  }
                }
              ]
            }
          ]
        }
    """.trimIndent()

    ApplicationLdJson(homeJsonLd)

    Box(
        Modifier.fillMaxSize(),
        contentAlignment = Alignment.TopCenter
    ) {
        NavHeader()

        Column(
            Modifier
                .fillMaxSize()
                .backgroundColor(AppTheme.colors.background),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            NavHeaderSpacer()

            HeroSection()

            SocialProofSection()

            HowToSection()

            FaqSection()

            BottomCtaSection()

            FooterSection()
        }
    }
}

val navHeaderHeightStyle = CssStyle {
    base {
        Modifier.height(70.px)
    }

    Breakpoint.SM {
        Modifier.height(75.px)
    }

    Breakpoint.MD {
        Modifier.height(90.px)
    }

    Breakpoint.LG {
        Modifier.height(110.px)
    }
}

@Composable
private fun NavHeaderSpacer() {
    Spacer(
        navHeaderHeightStyle
            .toModifier()
            .id("acasa")
    )
}

val landingSectionPaddingStyle = CssStyle {
    base {
        Modifier.padding(leftRight = 24.px, topBottom = 36.px)
    }

    Breakpoint.MD {
        Modifier.padding(leftRight = 24.px, topBottom = 46.px)
    }

    Breakpoint.LG {
        Modifier.padding(leftRight = 24.px, topBottom = 50.px)
    }

    Breakpoint.XL {
        Modifier.padding(topBottom = 54.px)
    }
}

val innerPaddingStyle = CssStyle {
    base {
        Modifier.height(16.px)
    }

    Breakpoint.MD {
        Modifier.height(24.px)
    }

    Breakpoint.LG {
        Modifier.height(28.px)
    }
}

val dynamicGapStyle = CssStyle {
    base {
        Modifier.gap(20.px)
    }

    Breakpoint.MD {
        Modifier.gap(24.px)
    }

    Breakpoint.LG {
        Modifier.gap(28.px)
    }
}

val heroStyle = CssStyle {
    base {
        Modifier
            .aspectRatio(0.75)
            .fillMaxWidth()
            .padding(left = 16.px, right = 16.px)
    }

    Breakpoint.MD {
        Modifier
            .aspectRatio(1.76)
            .fillMaxWidth()
            .padding(left = 24.px, right = 24.px)
    }
}

val heroImgStyle = CssStyle {
    base {
        Modifier.styleModifier {
            property("object-position", "${54.percent} ${0.percent}")
        }
    }

    Breakpoint.MD {
        Modifier.styleModifier {
            property("object-position", "${50.percent} ${0.percent}")
        }
    }
}

val heroTextStyle = CssStyle {
    base {
        Modifier
            .padding(leftRight = 24.px)
            .textAlign(TextAlign.Start)
    }

    Breakpoint.MD {
        Modifier
            .padding(leftRight = 40.px)
            .textAlign(TextAlign.Center)
    }
}

val heroSpacingStyle = CssStyle {
    base {
        Modifier.height(60.px)
    }

    Breakpoint.SM {
        Modifier.height(100.px)
    }

    Breakpoint.MD {
        Modifier.height(32.px)
    }
}

private const val HERO_IMAGE = "image"
private const val HERO_TEXT = "text"

@Composable
private fun HeroSection() {
    Box(
        heroStyle.toModifier(),
        contentAlignment = Alignment.Center,
        ref = rememberMotionRef { hero -> startHeroScrollEffect(hero) }
    ) {
        // Clips the image while it zooms in on scroll. The layers are explicit because the animated image is painted
        // above plain siblings, so without them it would cover the overlay that keeps the text readable
        Box(
            Modifier
                .fillMaxSize()
                .borderRadius(AppTheme.shapes.bigRound)
                .overflow(Overflow.Hidden)
                .position(Position.Relative)
                .zIndex(0)
        ) {
            Image(
                "/hero.webp",
                "Viitori medici rezidenți",
                heroImgStyle.toModifier()
                    .fillMaxSize()
                    .objectFit(ObjectFit.Cover)
                    .borderRadius(AppTheme.shapes.bigRound)
                    .userSelect(UserSelect.None)
                    .attr("data-hero", HERO_IMAGE)
            )

            Surface(
                Modifier
                    .backgroundColor(AppTheme.colors.hero)
                    .borderRadius(AppTheme.shapes.bigRound)
                    .fillMaxSize()
                    .position(Position.Relative)
                    .zIndex(1)
            ) {}
        }

        Column(
            Modifier
                .attr("data-hero", HERO_TEXT)
                .position(Position.Relative)
                .zIndex(1),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            Div(heroTextStyle.toAttrs()) {
                SpanText(
                    "Află în 2 minute specialitatea la ",
                    AppTheme.typography.title
                        .toModifier()
                        .color(AppTheme.colors.text)
                        .userSelect(UserSelect.None),
                )

                SpanText(
                    "Rezi",
                    AppTheme.typography.title
                        .toModifier()
                        .color(AppTheme.colors.accent)
                        // Use a shadow so this light-colored word is more visible in light mode
                        .textShadow(0.px, 0.px, blurRadius = 0.75.cssRem, color = Colors.Gray)
                        .userSelect(UserSelect.None)
                )
            }

            Spacer(innerPaddingStyle.toModifier())

            SpanText(
                "Descoperă specialitățile care ți se potrivesc cu noul Quiz de Orientare",
                AppTheme.typography.body1Medium.toModifier()
                    .then(heroTextStyle.toModifier())
                    .textAlign(TextAlign.Center)
                    .color(AppTheme.colors.textSecondary)
                    .userSelect(UserSelect.None),
            )

            Spacer(heroSpacingStyle.toModifier())

            val pageContext = rememberPageContext()
            CtaButton("Începe acum") {
                AppTracking.logEvent(
                    AppTracking.EVENT_LANDING_CTA_CLICK,
                    mapOf(AppTracking.PARAM_CTA_LOCATION to AppTracking.CTA_LOCATION_TOP)
                )
                pageContext.router.navigateTo("/quiz")
            }
        }
    }
}

/**
 * As the hero scrolls away, its image slowly zooms in while the text drifts down and fades out.
 *
 * The effect follows the scroll position, so at the top of the page the hero looks exactly like the pre-rendered one.
 */
private fun startHeroScrollEffect(hero: HTMLElement): () -> Unit {
    val image = hero.querySelector("[data-hero=$HERO_IMAGE]") ?: return {}
    val text = hero.querySelector("[data-hero=$HERO_TEXT]") ?: return {}

    val scrollOptions = json("target" to hero, "offset" to arrayOf("start start", "end start"))
    val linear = json("ease" to "linear")
    // Whole transform strings rather than Motion's separate x/y/scale values: these become native scroll-driven
    // animations that respect the offset above, while Motion's own per-value transforms follow the whole time the
    // hero is on screen instead, so they would already be part way through at the top of the page
    val imageZoom = json("transform" to arrayOf("scale(1)", "scale(1.08)"))
    val textDrift = json("opacity" to arrayOf(1, 0), "transform" to arrayOf("translateY(0px)", "translateY(80px)"))
    val stopEffects = listOf(
        scroll(animate(image, imageZoom, linear), scrollOptions),
        scroll(animate(text, textDrift, linear), scrollOptions)
    )

    return { stopEffects.forEach { it() } }
}

private data class SocialStat(
    val value: Int,
    val label: String
)

private val socialProofStats = listOf(
    SocialStat(10_000, "Studenți au Completat Quiz-ul"),
    SocialStat(97_500, "Recomandări Oferite"),
    SocialStat(243_000, "Întrebări Răspunse")
)

// 10000 -> "10,000+"
private fun formatSocialStat(value: Int): String =
    value.toString().reversed().chunked(3).joinToString(",").reversed() + "+"

private data class NewsHeadline(
    val logoUrl: String,
    val text: String
)

private val newsHeadlines = listOf(
    NewsHeadline(
        "/HotNews.webp",
        "“Dermatologia, radiologia și psihiatria, în topul specialităților medicale preferate de rezidenți”"
    ),
    NewsHeadline(
        "/Digi24.webp",
        "“Concursul de Rezidenţiat reprezintă principala poartă de intrare în multiplele specialităţi medicale”"
    ),
    NewsHeadline(
        "/Antena3.webp",
        "“Aproximativ 50% din personalul medical [...] este concentrat în Capitală şi în jurul centrelor universitare”"
    ),
    NewsHeadline(
        "/EVZ.webp",
        "“Mii de medici [...] din România lucrează în prezent în unitățile medicale din alte state ale Europei”"
    )
)

val newspaperItemStyle = CssStyle {
    base {
        Modifier
    }

    Breakpoint.MD {
        Modifier.maxWidth(280.px)
    }
}

val newspaperLogoStyle = CssStyle {
    base {
        Modifier.maxHeight(40.px)
    }

    Breakpoint.MD {
        Modifier.maxHeight(60.px)
    }

    Breakpoint.LG {
        Modifier.maxHeight(70.px)
    }
}

@Composable
private fun NewspaperItem(modifier: Modifier = Modifier, headline: NewsHeadline) {
    Column(
        modifier
            .then(newspaperItemStyle.toModifier())
    ) {
        Row {
            Image(
                headline.logoUrl,
                newspaperLogoStyle.toModifier()
                    .maxWidth(90.percent)
                    .filter(grayscale())
            )

            Spacer(Modifier.width(16.px))

            FaQuoteLeft(Modifier.color(AppTheme.colors.icon).maxWidth(10.percent))
        }

        Spacer(Modifier.height(20.px))

        SpanText(
            headline.text,
            AppTheme.typography.body1.toModifier()
                .color(AppTheme.colors.textTertiary)
                .fontStyle(FontStyle.Italic)
        )
    }
}

val iconSizeStyle = CssStyle {
    base {
        Modifier.size(24.px)
    }

    Breakpoint.MD {
        Modifier.size(36.px)
    }

    Breakpoint.LG {
        Modifier.size(48.px)
    }
}

val howToItemPaddingStyle = CssStyle {
    base {
        Modifier.padding(20.px)
    }

    Breakpoint.MD {
        Modifier.padding(30.px)
    }
}

val howToStepStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .alignItems(AlignItems.Stretch)
            .gap(28.px)
    }

    Breakpoint.MD {
        Modifier
            .flexDirection(FlexDirection.Row)
            .alignItems(AlignItems.Center)
            .gap(48.px)
    }

    Breakpoint.LG {
        Modifier.gap(72.px)
    }
}

val howToStepReversedStyle = CssStyle {
    Breakpoint.MD {
        Modifier.flexDirection(FlexDirection.RowReverse)
    }
}

val howToStepColumnStyle = CssStyle {
    base {
        Modifier.fillMaxWidth()
    }

    Breakpoint.MD {
        Modifier
            .flexGrow(1)
            .flexShrink(1)
            .flexBasis(0.px)
            .minWidth(0.px)
    }
}

val howToPreviewTiltStyle = CssStyle {
    base {
        Modifier.transition(Transition.of("transform", 300.ms, TransitionTimingFunction.EaseOut))
    }

    hover {
        Modifier.rotate(0.deg)
    }

    Breakpoint.MD {
        Modifier.rotate((-1.5).deg)
    }
}

val howToPreviewTiltReversedStyle = CssStyle {
    Breakpoint.MD {
        Modifier.rotate(1.5.deg)
    }
}

@Composable
private fun HowToSection() {
    Surface(
        Modifier
            .id("cum-functioneaza")
            .backgroundColor(AppTheme.colors.section)
            .fillMaxWidth(),
        contentAlignment = Alignment.Center
    ) {
        Column(
            MaxWidthStyle.toModifier()
                .then(landingSectionPaddingStyle.toModifier())
                .fillMaxWidth()
        ) {
            Reveal {
                SpanText(
                    "Cum funcționează?",
                    AppTheme.typography.h1.toModifier()
                        .color(AppTheme.colors.text)
                        .padding(bottom = 10.px)
                )
            }

            CoolLine()

            Spacer(Modifier.height(42.px))

            Column(Modifier.fillMaxWidth().gap(64.px)) {
                HowToStep(
                    number = 1,
                    title = "Răspunde la Întrebări",
                    text = "Completează Quiz-ul de Orientare despre personalitatea, abilitățile și preferințele tale. Nu e un test, nu există răspunsuri greșite."
                ) {
                    QuizPreview()
                }

                HowToStep(
                    number = 2,
                    title = "Primește Recomandări",
                    text = "Algoritmul nostru evaluează potrivirea dintre profilul tău și profilul ideal al fiecărei specialități și calculează un Scor de Potrivire.",
                    reversed = true
                ) {
                    RecommendationPreview()
                }

                HowToStep(
                    number = 3,
                    title = "Explorează Detaliile",
                    text = "Vezi recomandările personalizate și Analiza Detaliată, află de ce o specialitate ți se potrivește (sau nu), pe baza răspunsurilor tale."
                ) {
                    AnalysisPreview()
                }
            }
        }
    }
}

@Composable
private fun HowToStep(
    number: Int,
    title: String,
    text: String,
    reversed: Boolean = false,
    preview: @Composable () -> Unit
) {
    // The text comes in from its own side and the preview from the other one, or both from below when stacked
    val textSide = if (reversed) 1.0 else -1.0

    Div(
        howToStepStyle.toModifier()
            .then(if (reversed) howToStepReversedStyle.toModifier() else Modifier)
            .toAttrs()
    ) {
        Column(
            howToStepColumnStyle.toModifier(),
            ref = rememberMotionRef { column ->
                if (isHowToStepSideBySide()) {
                    revealOnScroll(column, x = textSide * 32, y = 0.0)
                } else {
                    revealOnScroll(column)
                }
            }
        ) {
            Box(ref = rememberMotionRef { circle -> revealOnScroll(circle, y = 0.0, scale = 0.5, delay = 0.15, spring = true) }) {
                NumberCircle(number)
            }

            Spacer(Modifier.height(20.px))

            SpanText(
                title,
                AppTheme.typography.h2.toModifier()
                    .color(AppTheme.colors.text)
                    .lineHeight(1.2)
            )

            Spacer(Modifier.height(12.px))

            SpanText(
                text,
                AppTheme.typography.body1.toModifier()
                    .color(AppTheme.colors.textSecondary)
            )
        }

        // Decorative, non-interactive glimpse of the real UI
        Box(
            howToStepColumnStyle.toModifier()
                .then(howToPreviewTiltStyle.toModifier())
                .then(if (reversed) howToPreviewTiltReversedStyle.toModifier() else Modifier)
                .maxWidth(560.px)
                .attr("aria-hidden", "true")
        ) {
            // Animated separately from the box above, so its CSS tilt (and un-tilting on hover) keeps working
            Box(
                Modifier
                    .fillMaxWidth()
                    .pointerEvents(PointerEvents.None)
                    .userSelect(UserSelect.None),
                ref = rememberMotionRef { inner ->
                    if (isHowToStepSideBySide()) {
                        revealOnScroll(inner, x = -textSide * 48, y = 0.0, scale = 0.97, delay = 0.12)
                    } else {
                        revealOnScroll(inner, y = 32.0, scale = 0.97, delay = 0.12)
                    }
                }
            ) {
                preview()
            }
        }
    }
}

// Matches the MD breakpoint, from which howToStepStyle puts the text and the preview side by side
private fun isHowToStepSideBySide(): Boolean = window.matchMedia("(min-width: 48em)").matches

// When the previews come to life, after they've slid in
private const val PREVIEW_DETAIL_DELAY_SECONDS = 0.4

private data class Testimonial(
    val text: String,
    val author: String,
    val avatarColor: String
)

private val featuredTestimonial = Testimonial(
    text = "Prima recomandare este fix ce urmează să aleg mâine.",
    author = "Student, Anul 6",
    avatarColor = "#FFB703"
)

private val testimonials = listOf(
    Testimonial(
        text = "Am avut o experiență foarte bună cu platforma. Sunt sigură că veți ajuta multe persoane, pentru mine testul chiar mi-a confirmat niște lucruri.",
        author = "Student, Anul 2",
        avatarColor = "#FB8500"
    ),
    Testimonial(
        text = "Ca acuratețe, din cele 10 sugestii, cam 8 pot să zic că îmi plac și le iau în considerare.",
        author = "Student, Anul 5",
        avatarColor = "#219EBC"
    ),
    Testimonial(
        text = "Am o colegă care e de ani de zile voluntară pe ambulanță, și i-a ieșit acest rezultat: Medicina de Urgență.",
        author = "Student, Anul 5",
        avatarColor = "#8ECAE6"
    ),
    Testimonial(
        text = "Mă bucur să aud că lucrați la îmbunătățirea platformei și vă doresc mult succes în dezvoltarea proiectului. Chiar e nevoie de astfel de inițiative pentru studenți.",
        author = "Student, Anul 4",
        avatarColor = "#023047"
    )
)

@Composable
private fun FeaturedTestimonial(modifier: Modifier = Modifier, testimonial: Testimonial) {
    Column(
        modifier
            .fillMaxWidth()
            .maxWidth(900.px),
        horizontalAlignment = Alignment.CenterHorizontally,
        ref = rememberMotionRef { column -> revealOnScroll(column) }
    ) {
        Box(ref = rememberMotionRef { quote -> revealOnScroll(quote, y = 0.0, scale = 0.6, delay = 0.1, spring = true) }) {
            FaQuoteLeft(
                Modifier.color(AppTheme.colors.icon),
                size = IconSize.X3
            )
        }

        Spacer(Modifier.height(16.px))

        SpanText(
            testimonial.text,
            AppTheme.typography.h2.toModifier()
                .color(AppTheme.colors.text)
                .textAlign(TextAlign.Center)
        )

        Spacer(Modifier.height(20.px))

        TestimonialAuthor(testimonial)
    }
}

@Composable
private fun TestimonialCard(modifier: Modifier = Modifier, testimonial: Testimonial) {
    Column(
        modifier
            .borderRadius(AppTheme.shapes.bigRound)
            .backgroundColor(AppTheme.colors.section)
            .then(howToItemPaddingStyle.toModifier())
    ) {
        FaQuoteLeft(
            Modifier
                .color(AppTheme.colors.icon)
                // Make the icon box hug the glyph (FA's own line height lets it overflow into the padding),
                // so the space above the quote marks matches the card padding below the author
                .lineHeight(0.625),
            size = IconSize.XL
        )

        Spacer(Modifier.height(16.px))

        SpanText(
            testimonial.text,
            AppTheme.typography.body1.toModifier()
                .color(AppTheme.colors.textSecondary)
                .flexGrow(1)
        )

        Spacer(Modifier.height(24.px))

        TestimonialAuthor(testimonial)
    }
}

@Composable
private fun TestimonialAuthor(testimonial: Testimonial) {
    Row(verticalAlignment = Alignment.CenterVertically) {
        Box(
            Modifier
                .size(44.px)
                .flexShrink(0)
                .borderRadius(50.percent)
                .backgroundColor(Color(testimonial.avatarColor))
                .border(3.px, LineStyle.Solid, AppTheme.colors.background),
            contentAlignment = Alignment.Center
        ) {
            FaUserGraduate(Modifier.color(Colors.White))
        }

        Spacer(Modifier.width(12.px))

        SpanText(
            testimonial.author,
            AppTheme.typography.body1Medium.toModifier()
                .color(AppTheme.colors.text)
        )
    }
}

val socialSectionPaddingStyle = CssStyle {
    base {
        Modifier.padding(topBottom = 36.px)
    }

    Breakpoint.MD {
        Modifier.padding(topBottom = 46.px)
    }

    Breakpoint.LG {
        Modifier.padding(topBottom = 50.px)
    }

    Breakpoint.XL {
        Modifier.padding(topBottom = 54.px)
    }
}

val socialProofContainerStyle = CssStyle {
    base {
        Modifier.gap(8.px)
    }

    Breakpoint.MD {
        Modifier.gap(24.px)
    }

    Breakpoint.LG {
        Modifier.gap(32.px)
    }
}

val socialProofItemStyle = CssStyle {
    base {
        Modifier.padding(topBottom = 16.px, leftRight = 6.px)
    }

    Breakpoint.MD {
        Modifier.padding(24.px)
    }

    Breakpoint.LG {
        Modifier.padding(32.px)
    }
}

val socialProofNumberStyle = CssStyle {
    // Scales with the screen so the three numbers fit on one row on phones too
    base {
        Modifier.styleModifier {
            property("font-size", "clamp(16px, 5.4vw, 22px)")
        }
    }

    Breakpoint.SM {
        Modifier.fontSize(28.px)
    }

    Breakpoint.MD {
        Modifier.fontSize(40.px)
    }

    Breakpoint.LG {
        Modifier.fontSize(48.px)
    }
}

// Gap and trailing padding must match, so each marquee copy ends exactly one gap before the next one starts
val newsMarqueeSpacingStyle = CssStyle {
    base {
        Modifier.gap(48.px).padding(right = 48.px)
    }

    Breakpoint.MD {
        Modifier.gap(72.px).padding(right = 72.px)
    }
}

val testimonialsMarqueeSpacingStyle = CssStyle {
    base {
        Modifier.gap(16.px).padding(right = 16.px)
    }

    Breakpoint.MD {
        Modifier.gap(24.px).padding(right = 24.px)
    }
}

val marqueeNewsItemStyle = CssStyle {
    base {
        Modifier.width(240.px)
    }

    Breakpoint.MD {
        Modifier.width(280.px)
    }
}

val marqueeTestimonialItemStyle = CssStyle {
    base {
        Modifier.width(280.px)
    }

    Breakpoint.MD {
        Modifier.width(340.px)
    }
}

@Composable
private fun SocialProofSection() {
    Column(
        socialSectionPaddingStyle.toModifier()
            .id("pareri")
            .fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Column(
            MaxWidthStyle.toModifier().fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Reveal {
                SpanText(
                    "Ce spun colegii tăi",
                    AppTheme.typography.h1.toModifier()
                        .color(AppTheme.colors.text)
                        .textAlign(TextAlign.Center)
                        .padding(leftRight = 24.px)
                        .margin(bottom = 24.px)
                )
            }

            FeaturedTestimonial(
                Modifier.padding(leftRight = 24.px),
                featuredTestimonial
            )

            Spacer(Modifier.height(40.px))

            // Stays on one row while the numbers fit, wraps on very narrow screens
            Row(
                socialProofContainerStyle.toModifier()
                    .fillMaxWidth()
                    .padding(leftRight = 24.px)
                    .flexWrap(FlexWrap.Wrap)
                    .alignItems(AlignItems.Stretch),
                horizontalArrangement = Arrangement.Center,
                ref = rememberMotionRef { row -> revealChildrenOnScroll(row, staggerSeconds = SOCIAL_STAT_STAGGER_SECONDS) }
            ) {
                socialProofStats.forEachIndexed { index, stat ->
                    SocialProofItem(stat, countUpDelay = index * SOCIAL_STAT_STAGGER_SECONDS)
                }
            }
        }

        Spacer(Modifier.height(48.px))

        // The marquees run the full width of the screen, not just the content column.
        // Plain fades: they already move on their own
        Reveal(Modifier.fillMaxWidth(), y = 0.0, duration = CAROUSEL_FADE_SECONDS, amount = CAROUSEL_VISIBLE_AMOUNT) {
            Marquee(testimonialsMarqueeSpacingStyle, pixelsPerSecond = 27.5) {
                testimonials.forEach { testimonial ->
                    TestimonialCard(
                        marqueeTestimonialItemStyle.toModifier().flexShrink(0),
                        testimonial
                    )
                }
            }
        }

        Spacer(Modifier.height(48.px))

        Reveal(Modifier.fillMaxWidth(), y = 0.0, duration = CAROUSEL_FADE_SECONDS, amount = CAROUSEL_VISIBLE_AMOUNT) {
            Marquee(newsMarqueeSpacingStyle, pixelsPerSecond = 30.8, reverse = true) {
                newsHeadlines.forEach { headline ->
                    NewspaperItem(
                        marqueeNewsItemStyle.toModifier().flexShrink(0),
                        headline
                    )
                }
            }
        }
    }
}

private const val SOCIAL_STAT_STAGGER_SECONDS = 0.1

// The carousels fade in more slowly than the rest of the page, once 10% of their height is on screen
private const val CAROUSEL_FADE_SECONDS = 1.5
private const val CAROUSEL_VISIBLE_AMOUNT = 0.1

@Composable
private fun SocialProofItem(
    stat: SocialStat,
    countUpDelay: Double
) {
    // Starts at the final value, so it's correct in the pre-rendered page and when effects are off
    var displayedValue by remember { mutableStateOf(stat.value) }

    Column(
        socialProofItemStyle.toModifier()
            .flexGrow(1)
            .flexShrink(1)
            .flexBasis(0.px)
            .maxWidth(320.px)
            .borderRadius(AppTheme.shapes.bigRound)
            .backgroundColor(AppTheme.colors.surface),
        horizontalAlignment = Alignment.CenterHorizontally,
        ref = rememberMotionRef { card ->
            countUpOnScroll(card, stat.value, delay = countUpDelay) { displayedValue = it }
        }
    ) {
        SpanText(
            formatSocialStat(displayedValue),
            socialProofNumberStyle.toModifier()
                .color(AppTheme.colors.icon)
                .fontWeight(FontWeight.Bold)
                .lineHeight(1)
                .whiteSpace(WhiteSpace.NoWrap)
                .userSelect(UserSelect.None)
                // Equal-width digits, so the number doesn't wobble while it counts up
                .styleModifier { property("font-variant-numeric", "tabular-nums") }
        )

        Spacer(Modifier.height(8.px))

        SpanText(
            stat.label,
            AppTheme.typography.body2.toModifier()
                .color(AppTheme.colors.textSecondary)
                .textAlign(TextAlign.Center)
                .userSelect(UserSelect.None)
        )
    }
}

val marqueeStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .overflow(Overflow.Hidden)
            // Horizontal swipes drag the marquee, vertical ones still scroll the page
            .styleModifier {
                property("touch-action", "pan-y")
                val fadeMask = "linear-gradient(to right, transparent, black 24px, black calc(100% - 24px), transparent)"
                property("mask-image", fadeMask)
                property("-webkit-mask-image", fadeMask)
            }
    }

    Breakpoint.MD {
        Modifier.styleModifier {
            val fadeMask = "linear-gradient(to right, transparent, black 64px, black calc(100% - 64px), transparent)"
            property("mask-image", fadeMask)
            property("-webkit-mask-image", fadeMask)
        }
    }
}

// How long the marquee takes to slow down to a stop on hover and to speed back up after
private const val MARQUEE_EASING_SECONDS = 0.25

// How long a swipe keeps gliding before the marquee settles back to its own speed
private const val MARQUEE_FLING_EASING_SECONDS = 0.5

// A swipe can't fling the marquee faster than this
private const val MARQUEE_MAX_FLING_PIXELS_PER_SECOND = 2000.0

// A finger held still for this long before lifting doesn't fling the marquee
private const val MARQUEE_FLING_TIMEOUT_MS = 100.0

/**
 * Slowly scrolls [content] horizontally in an endless loop, slowing down to a stop while hovered with a mouse.
 * On touch screens it can be dragged with a finger, and glides back to its own speed once let go.
 *
 * The content is rendered several times side by side, and the track is shifted by the width of one copy,
 * at which point the second copy is exactly where the first one started. There are always enough copies to cover
 * the marquee's width even while shifted, so wide screens never see the end of the track.
 */
@Composable
private fun Marquee(
    spacingStyle: CssStyle<GeneralKind>,
    pixelsPerSecond: Double,
    reverse: Boolean = false,
    content: @Composable () -> Unit
) {
    val reduceMotion = remember { prefersReducedMotion() }

    if (reduceMotion) {
        // Don't animate, let people scroll through the items themselves.
        // The first item lines up with the content column above, however wide the screen is
        Row(
            spacingStyle.toModifier()
                .fillMaxWidth()
                .styleModifier { property("padding-left", "max(24px, calc((100% - 1200px) / 2 + 24px))") }
                .overflow { x(Overflow.Auto) }
                .alignItems(AlignItems.Stretch)
        ) {
            content()
        }
        return
    }

    var copies by remember { mutableStateOf(2) }

    Row(marqueeStyle.toModifier()) {
        Row(
            Modifier
                .flexShrink(0)
                .styleModifier {
                    property("will-change", "transform")
                },
            ref = disposableRef { track ->
                val stopScrolling = startMarqueeScrolling(track, pixelsPerSecond, reverse) { copies = it }
                onDispose { stopScrolling() }
            }
        ) {
            repeat(copies) { index ->
                Row(
                    spacingStyle.toModifier()
                        .flexShrink(0)
                        .alignItems(AlignItems.Stretch)
                        // Screen readers only need to read the items once
                        .then(if (index > 0) Modifier.ariaHidden() else Modifier)
                ) {
                    content()
                }
            }
        }
    }
}

/**
 * Moves the marquee [track] frame by frame and returns a function that stops it.
 *
 * This is done here instead of with a CSS animation, because pausing a CSS animation on hover makes Chrome
 * snap it back a few pixels. It also lets the marquee ease to a stop instead of freezing abruptly.
 *
 * Reports through [onCopiesNeeded] how many copies of the content it takes to cover the marquee, e.g. after a resize.
 */
private fun startMarqueeScrolling(
    track: HTMLElement,
    pixelsPerSecond: Double,
    reverse: Boolean,
    onCopiesNeeded: (Int) -> Unit
): () -> Unit {
    var offset = 0.0
    var speed = pixelsPerSecond
    var easingSeconds = MARQUEE_EASING_SECONDS
    var paused = false
    var lastFrameTime: Double? = null
    var frameId = 0
    var copiesNeeded = 0

    // The finger currently dragging the marquee, if any
    var dragPointerId: Int? = null
    var lastDragX = 0.0
    var lastDragTime = 0.0
    var dragVelocity = 0.0

    // The offset grows as the content moves left, or right when reversed
    val offsetPerDragPixel = if (reverse) 1.0 else -1.0

    fun onFrame(time: Double) {
        // Capped, so the marquee doesn't jump after the tab was in the background
        val elapsedSeconds = lastFrameTime?.let { ((time - it) / 1000).coerceAtMost(0.1) } ?: 0.0
        lastFrameTime = time

        // While dragged, only the finger moves the marquee
        if (dragPointerId == null) {
            val targetSpeed = if (paused) 0.0 else pixelsPerSecond
            speed += (targetSpeed - speed) * (elapsedSeconds / easingSeconds).coerceAtMost(1.0)
        }

        val copyWidth = (track.firstElementChild as? HTMLElement)?.offsetWidth?.toDouble() ?: 0.0
        if (copyWidth > 0) {
            if (dragPointerId == null) offset += speed * elapsedSeconds
            // Dragging or flinging backwards can make the offset negative
            offset = (offset % copyWidth + copyWidth) % copyWidth
            val x = if (reverse) offset - copyWidth else -offset
            track.style.transform = "translate3d(${x}px, 0, 0)"

            // The track is shifted by up to one copy, so it must reach one copy past the visible width
            val visibleWidth = (track.parentElement as? HTMLElement)?.clientWidth?.toDouble() ?: 0.0
            val needed = maxOf(2, ceil(visibleWidth / copyWidth).toInt() + 1)
            if (needed != copiesNeeded) {
                copiesNeeded = needed
                onCopiesNeeded(needed)
            }
        }

        frameId = window.requestAnimationFrame(::onFrame)
    }

    // Only a mouse pauses the marquee; on touch screens it keeps moving
    val pause: (Event) -> Unit = { event ->
        if (event.unsafeCast<PointerEvent>().pointerType == "mouse") {
            paused = true
            easingSeconds = MARQUEE_EASING_SECONDS
        }
    }
    val resume: (Event) -> Unit = { paused = false }

    // Only touch and pen drag the marquee, a mouse just pauses it
    val startDrag: (Event) -> Unit = { event ->
        val pointer = event.unsafeCast<PointerEvent>()
        if (pointer.pointerType != "mouse" && dragPointerId == null) {
            dragPointerId = pointer.pointerId
            lastDragX = pointer.clientX.toDouble()
            lastDragTime = pointer.timeStamp.toDouble()
            dragVelocity = 0.0
            speed = 0.0
        }
    }
    val drag: (Event) -> Unit = { event ->
        val pointer = event.unsafeCast<PointerEvent>()
        if (pointer.pointerId == dragPointerId) {
            val x = pointer.clientX.toDouble()
            val time = pointer.timeStamp.toDouble()
            val offsetDelta = (x - lastDragX) * offsetPerDragPixel
            offset += offsetDelta

            // Smoothed, so a single uneven touch event doesn't decide how fast the marquee glides after
            val elapsedSeconds = (time - lastDragTime) / 1000
            if (elapsedSeconds > 0) {
                dragVelocity = 0.7 * (offsetDelta / elapsedSeconds) + 0.3 * dragVelocity
            }
            lastDragX = x
            lastDragTime = time
        }
    }
    val endDrag: (Event) -> Unit = { event ->
        val pointer = event.unsafeCast<PointerEvent>()
        if (pointer.pointerId == dragPointerId) {
            dragPointerId = null
            // A swipe carries on in its direction, then the marquee eases back to its own speed
            val heldStill = pointer.timeStamp.toDouble() - lastDragTime > MARQUEE_FLING_TIMEOUT_MS
            val isFling = event.type == "pointerup" && !heldStill
            speed = if (isFling) {
                dragVelocity.coerceIn(-MARQUEE_MAX_FLING_PIXELS_PER_SECOND, MARQUEE_MAX_FLING_PIXELS_PER_SECOND)
            } else {
                0.0
            }
            easingSeconds = MARQUEE_FLING_EASING_SECONDS
        }
    }

    val listeners = listOf(
        "pointerenter" to pause,
        "pointerleave" to resume,
        "pointerdown" to startDrag,
        "pointermove" to drag,
        "pointerup" to endDrag,
        // Also sent when the page takes over the gesture, e.g. for a vertical scroll
        "pointercancel" to endDrag
    )
    listeners.forEach { (type, listener) -> track.addEventListener(type, listener) }
    frameId = window.requestAnimationFrame(::onFrame)

    return {
        window.cancelAnimationFrame(frameId)
        listeners.forEach { (type, listener) -> track.removeEventListener(type, listener) }
    }
}

@Composable
private fun PreviewFrame(path: String, content: @Composable () -> Unit) {
    Column(
        Modifier
            .fillMaxWidth()
            .backgroundColor(AppTheme.colors.surface)
            .borderRadius(AppTheme.shapes.bigRound)
            .boxShadow(0.px, 12.px, 32.px, 0.px, rgba(2, 48, 71, 0.18))
            .overflow(Overflow.Hidden)
    ) {
        // Window bar
        Row(
            Modifier
                .fillMaxWidth()
                .padding(leftRight = 16.px, topBottom = 12.px)
                .gap(6.px)
                .borderBottom(1.px, LineStyle.Solid, rgba(128, 128, 128, 0.2)),
            verticalAlignment = Alignment.CenterVertically
        ) {
            listOf("#FF5F57", "#FEBC2E", "#28C840").forEach { color ->
                Box(
                    Modifier
                        .size(10.px)
                        .borderRadius(50.percent)
                        .backgroundColor(Color(color))
                )
            }

            Spacer(Modifier.width(8.px))

            SpanText(
                "rezident.info$path",
                AppTheme.typography.body2.toModifier()
                    .color(AppTheme.colors.textTertiary)
                    .fontSize(13.px)
            )
        }

        Column(Modifier.fillMaxWidth().padding(20.px)) {
            content()
        }
    }
}

@Composable
private fun QuizPreview() {
    PreviewFrame("/quiz") {
        // Quiz progress
        Box(
            Modifier
                .fillMaxWidth()
                .height(6.px)
                .backgroundColor(rgba(128, 128, 128, 0.2))
                .borderRadius(3.px)
                .margin(bottom = 20.px)
        ) {
            Box(
                Modifier
                    .width(40.percent)
                    .height(6.px)
                    .backgroundColor(AppTheme.colors.accent)
                    .borderRadius(3.px),
                ref = rememberMotionRef { bar ->
                    playOnFirstView(
                        bar,
                        prepare = { bar.style.width = "0%" },
                        play = {
                            animate(
                                bar,
                                json("width" to arrayOf("0%", "40%")),
                                json("duration" to 0.9, "delay" to PREVIEW_DETAIL_DELAY_SECONDS, "ease" to RevealEase)
                            )
                        }
                    )
                }
            )
        }

        SpanText(
            "Stabilitate Emoțională",
            AppTheme.typography.body2.toModifier()
                .color(AppTheme.colors.textTertiary)
                .margin(bottom = 8.px)
        )

        SpanText(
            "Cât de bine funcționezi în situații tensionate, sub presiune?",
            AppTheme.typography.h2.toModifier()
                .color(AppTheme.colors.text)
                .lineHeight(1.3)
                .margin(bottom = 8.px)
        )

        FiveScaleSlider(value = 4, onValueChange = {})

        Row(
            Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(
                "1 = Deloc · 5 = Foarte bine",
                AppTheme.typography.body2.toModifier()
                    .color(AppTheme.colors.textTertiary)
            )

            Row(
                Modifier
                    .backgroundColor(AppTheme.colors.accent)
                    .borderRadius(AppTheme.shapes.mediumRound)
                    .padding(leftRight = 16.px, topBottom = 8.px)
                    .gap(8.px)
                    .flexShrink(0),
                verticalAlignment = Alignment.CenterVertically
            ) {
                SpanText(
                    "Continuă",
                    AppTheme.typography.body2.toModifier()
                        .color(AppTheme.colors.onAccent)
                        .fontWeight(FontWeight.Medium)
                )
                FaArrowRight(Modifier.color(AppTheme.colors.onAccent))
            }
        }
    }
}

private val previewRecommendation = RecommendationItem(
    rank = 1,
    name = "Medicină de Urgență",
    matchScore = 92,
    pros = listOf(
        "Ai spus că iubești adrenalina, exact ce cere această specialitate.",
        "Iei decizii rapide sub presiune, un atu esențial în urgențe."
    ),
    cons = listOf(
        "Prețuiești echilibrul muncă-viață, dar specialitatea implică multe gărzi."
    ),
    characteristics = listOf("Medicală", "Stres Ridicat", "Acuți")
)

@Composable
private fun RecommendationPreview() {
    // Card stack: the top recommendation, with #2 and #3 peeking from behind
    Box(
        Modifier
            .fillMaxWidth()
            .position(Position.Relative)
            .padding(bottom = 24.px)
    ) {
        listOf(32.px to 0.4, 16.px to 0.7).forEachIndexed { index, (inset, alpha) ->
            // How far the card peeks out below the top one, which is how far it starts tucked up behind it
            val peek = (24 - index * 12).toDouble()

            Box(
                Modifier
                    .position(Position.Absolute)
                    .left(inset)
                    .right(inset)
                    .bottom((index * 12).px)
                    .height(80.px)
                    .backgroundColor(AppTheme.colors.surface)
                    .border(1.px, LineStyle.Solid, AppTheme.colors.textTertiary)
                    .borderRadius(AppTheme.shapes.mediumRound)
                    .opacity(alpha),
                // The cards fan out from behind the top one, the closest one first
                ref = rememberMotionRef { card ->
                    playOnFirstView(
                        card,
                        prepare = { card.style.transform = "translateY(-${peek}px)" },
                        play = {
                            animate(
                                card,
                                json("y" to arrayOf(-peek, 0)),
                                springTransition(delay = PREVIEW_DETAIL_DELAY_SECONDS + (1 - index) * 0.1)
                            )
                        }
                    )
                }
            )
        }

        RecommendationCardContent(
            recommendation = previewRecommendation,
            scoreAnimationDelaySeconds = PREVIEW_DETAIL_DELAY_SECONDS,
            modifier = Modifier
                .position(Position.Relative)
                .zIndex(1)
                .boxShadow(0.px, 12.px, 32.px, 0.px, rgba(2, 48, 71, 0.18))
        )
    }
}

@Composable
private fun AnalysisPreview() {
    var displayedScore by remember { mutableStateOf(previewRecommendation.matchScore) }

    // Styled like the recommendation card from step 2
    Column(
        Modifier
            .fillMaxWidth()
            .backgroundColor(AppTheme.colors.surface)
            .borderRadius(AppTheme.shapes.mediumRound)
            .border(1.px, LineStyle.Solid, AppTheme.colors.textTertiary)
            .boxShadow(0.px, 12.px, 32.px, 0.px, rgba(2, 48, 71, 0.18))
            .padding(20.px),
        ref = rememberMotionRef { card ->
            countUpOnScroll(card, previewRecommendation.matchScore, delay = PREVIEW_DETAIL_DELAY_SECONDS) {
                displayedScore = it
            }
        }
    ) {
        Row(
            Modifier.fillMaxWidth().gap(12.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(
                Modifier
                    .size(36.px)
                    .backgroundColor(AppTheme.colors.section)
                    .borderRadius(6.px)
                    .flexShrink(0),
                contentAlignment = Alignment.Center
            ) {
                SpanText("🚑", Modifier.fontSize(22.px))
            }

            Column(Modifier.weight(1)) {
                SpanText(
                    previewRecommendation.name,
                    AppTheme.typography.body1Medium.toModifier()
                        .color(AppTheme.colors.text)
                        .lineHeight(1.2)
                )
                SpanText(
                    "Analiza Detaliată",
                    AppTheme.typography.body2.toModifier()
                        .color(AppTheme.colors.textTertiary)
                )
            }

            SpanText(
                "$displayedScore%",
                AppTheme.typography.body2.toModifier()
                    .color(Colors.White)
                    .fontWeight(FontWeight.Bold)
                    .backgroundColor(Color("#22c55e"))
                    .borderRadius(AppTheme.shapes.mediumRound)
                    .padding(leftRight = 12.px, topBottom = 4.px)
                    .flexShrink(0)
                    // Same width for one and two digits, so nothing next to it moves while the score counts up
                    .textAlign(TextAlign.Center)
                    .styleModifier {
                        property("font-variant-numeric", "tabular-nums")
                        property("min-width", "calc(3.5ch + 24px)")
                    }
            )
        }

        Box(
            Modifier
                .fillMaxWidth()
                .height(1.px)
                .backgroundColor(rgba(128, 128, 128, 0.2))
                .margin(topBottom = 16.px)
        )

        ProConsList(
            title = "Puncte Forte",
            recommendations = previewRecommendation.pros,
            isPros = true
        )

        Spacer(Modifier.height(16.px))

        ProConsList(
            title = "Puncte Slabe",
            recommendations = previewRecommendation.cons,
            isPros = false
        )
    }
}

@Composable
private fun FaqSection() {
    Column(
        MaxWidthStyle.toModifier()
            .then(landingSectionPaddingStyle.toModifier())
            .id("intrebari")
            .fillMaxWidth()
    ) {
        Reveal {
            SpanText(
                "Întrebări frecvente",
                AppTheme.typography.h1.toModifier()
                    .color(AppTheme.colors.text)
                    .padding(bottom = 10.px)
            )
        }

        CoolLine()

        Spacer(Modifier.height(42.px))

        Column(
            dynamicGapStyle.toModifier()
                .fillMaxWidth()
                .maxWidth(1000.px)
                .align(Alignment.CenterHorizontally),
            ref = rememberMotionRef { list -> revealChildrenOnScroll(list, staggerSeconds = 0.05) }
        ) {
            FaqItem(
                id = 1,
                question = "Ce este Quiz-ul de Orientare?",
                answer = "Este un instrument de autocunoaștere, nu un test. Răspunzi la întrebări despre personalitatea și preferințele tale, și afli ce specialități medicale se potrivesc cel mai bine cu criteriile pe care ți le dorești."
            )

            FaqItem(
                id = 7,
                question = "Cum funcționează? Îmi \"ghicește\" specialitatea potrivită?",
                answer = "Nu ghicim. Platforma compară profilul tău, creat pe baza răspunsurilor tale, cu profilul \"ideal\" al fiecărei specialități (ex. Cardiologia necesită rezistență ridicată la stres). Algoritmul nostru calculează cât de bine se potrivesc aceste două profiluri."
            )

            FaqItem(
                id = 2,
                question = "Cât de precise sunt rezultatele Quiz-ului?",
                answer = "Precizia rezultatelor depinde de două lucruri, onestitatea ta și datele noastre - cu cât răspunzi mai sincer, cu atât profilul tău va fi mai corect." +
                        " Profilurile specialităților nu sunt bazate pe opinii subiective. Acestea au fost meticulos construite folosind informații din ghidurile oficiale de rezidențiat, fișele de specialitate și descrierile profesionale ale mediilor de lucru."
            )

            FaqItem(
                id = 8,
                question = "Rezultatul îmi va spune exact ce specialitate să aleg?",
                answer = "Nu. Gândește-te la Quiz-ul de Orientare ca la o busolă." +
                        " Rolul lui este să îți arate o direcție. Îți poate valida alegerile pe care le luai deja în considerare sau, și mai important, îți poate evidenția specialități la care poate nu te-ai fi gândit niciodată, dar care se potrivesc surprinzător de bine cu profilul tău."
            )

            FaqItem(
                id = 9,
                question = "Ce voi primi la finalul Quiz-ului?",
                answer = "Vei primi un clasament personalizat al tuturor specialităților, sortate de la cea mai mică la cea mai mare potrivire, cu un scor procentual (ex. 95%)." +
                        " Funcția de Analiză Detaliată îți arată de ce ți se potrivește." +
                        " Puncte Forte: Profilul tău se aliniază exact cu cerințele (de ex., \"Tu ai spus că iubești adrenalina, iar Medicina de Urgență exact asta cere.\")." +
                        "\n" +
                        " Puncte Slabe: Preferințele tale diferă de cerințe (de ex., \"Tu prețuiești enorm echilibrul muncă-viață, dar Chirurgia Cardiovasculară implică multe gărzi.\")."
            )

            FaqItem(
                id = 3,
                question = "Cât durează Quiz-ul?",
                answer = "Câteva minute. Îți recomandăm să nu te grăbești și să răspunzi cât mai sincer pentru a obține cel mai relevant rezultat."
            )

            FaqItem(
                id = 4,
                question = "Pot repeta Quiz-ul?",
                answer = "Poți repeta Quiz-ul de Orientare de câte ori dorești, în caz că vrei să încerci răspunsuri diferite."
            )

            FaqItem(
                id = 5,
                question = "Quiz-ul de Orientare este gratuit?",
                answer = "Scopul rezident.info este să ajute cât mai mulți studenți să se informeze. Quiz-ul de Orientare și Recomandările sunt gratis. Funcția de Analiza Detaliată are un cost simbolic, pentru cei entuziasmați."
            )

            FaqItem(
                id = 6,
                question = "Datele mele sunt în siguranță?",
                answer = "Da. Răspunsurile tale sunt criptate, folosite doar pentru algoritmul de potrivire și nu sunt partajate cu terți."
            )
        }
    }
}

private class ElementHolder {
    var element: HTMLElement? = null
}

private const val FAQ_ANSWER_SECONDS = 0.3

/** Animates a FAQ answer open from its current height, then lets it size itself again once [isStillOpen]. */
private fun openFaqAnswer(answer: HTMLElement, isStillOpen: () -> Boolean) {
    animate(
        answer,
        json("height" to arrayOf(answer.offsetHeight, answer.scrollHeight), "opacity" to 1),
        json("duration" to FAQ_ANSWER_SECONDS, "ease" to RevealEase)
    ).finished.then {
        // So it still fits if the text wraps differently later, e.g. after rotating the phone
        if (isStillOpen()) answer.style.height = "auto"
    }
}

private fun closeFaqAnswer(answer: HTMLElement): AnimationPlaybackControls = animate(
    answer,
    json("height" to arrayOf(answer.offsetHeight, 0), "opacity" to 0),
    json("duration" to FAQ_ANSWER_SECONDS, "ease" to RevealEase)
)

@Composable
private fun FaqItem(
    id: Int,
    question: String,
    answer: String
) {
    val motionEnabled = rememberMotionEnabled()
    var expanded by remember { mutableStateOf(false) }
    // Stays true while the answer animates closed, so it's only removed once it's out of sight
    var answerShown by remember { mutableStateOf(false) }
    val answerBox = remember { ElementHolder() }
    val arrow = remember { ElementHolder() }

    Box(
        modifier = Modifier
            .backgroundColor(AppTheme.colors.surface)
            .fillMaxWidth()
            .cursor(Cursor.Pointer)
            .padding(30.px)
            .border(2.px, LineStyle.Solid, AppTheme.colors.text)
            .borderRadius(AppTheme.shapes.mediumRound)
            .onClick {
                if (!expanded) {
                    // Only track when expanding, not when collapsing
                    AppTracking.logEvent(
                        AppTracking.EVENT_LANDING_FAQ_CLICK,
                        mapOf(AppTracking.PARAM_FAQ_ID to id.toString())
                    )
                }
                expanded = !expanded

                val answerElement = answerBox.element
                when {
                    // Without effects it simply appears and disappears, otherwise it animates open once it's added
                    !motionEnabled || answerElement == null -> answerShown = expanded
                    // Reopened before it finished closing
                    expanded -> openFaqAnswer(answerElement) { expanded }
                    else -> closeFaqAnswer(answerElement).finished.then { if (!expanded) answerShown = false }
                }

                if (motionEnabled) {
                    arrow.element?.let { animate(it, json("rotate" to if (expanded) 180 else 0), springTransition()) }
                }
            },
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
        ) {
            // Question row + arrow icon
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {
                SpanText(
                    question,
                    AppTheme.typography.body1Medium.toModifier()
                        .fillMaxWidth()
                        .color(AppTheme.colors.textSecondary)
                        .textOverflow(TextOverflow.Ellipsis)
                        .weight(1)
                )

                // Spun with a spring on click when effects are on, otherwise just flipped
                Box(
                    if (!motionEnabled && expanded) Modifier.rotate(180.deg) else Modifier,
                    ref = disposableRef { element ->
                        arrow.element = element
                        onDispose { arrow.element = null }
                    }
                ) {
                    FaAngleDown(Modifier.color(AppTheme.colors.icon))
                }
            }

            if (answerShown) {
                Box(
                    Modifier
                        .fillMaxWidth()
                        .overflow(Overflow.Hidden),
                    ref = disposableRef { element ->
                        answerBox.element = element
                        if (motionEnabled) {
                            element.style.height = "0px"
                            element.style.opacity = "0"
                            openFaqAnswer(element) { expanded }
                        }
                        onDispose { answerBox.element = null }
                    }
                ) {
                    SpanText(
                        text = answer,
                        AppTheme.typography.body1.toModifier()
                            .color(AppTheme.colors.text),
                    )
                }
            }
        }
    }
}

val bottomCtaStyle = CssStyle {
    base {
        Modifier.textAlign(TextAlign.Start)
    }

    Breakpoint.MD {
        Modifier.textAlign(TextAlign.Center)
    }
}

@Composable
private fun BottomCtaSection() {
    Surface(
        Modifier
            .backgroundColor(AppTheme.colors.section)
            .fillMaxWidth()
            .then(landingSectionPaddingStyle.toModifier()),
        contentAlignment = Alignment.Center
    ) {
        Column(
            MaxWidthStyle.toModifier(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Reveal {
                SpanText(
                    "Ești gata să îți descoperi specialitatea?",
                    AppTheme.typography.h1.toModifier()
                        .then(bottomCtaStyle.toModifier())
                        .color(AppTheme.colors.text),
                )
            }

            Spacer(Modifier.height(24.px))

            Reveal(delay = 0.1) {
                SpanText(
                    "Răspunde la câteva întrebări și primește instant o Analiză Detaliată a specialităților potrivite ție la Rezi.",
                    AppTheme.typography.body1.toModifier()
                        .color(AppTheme.colors.textSecondary),
                )
            }

            Spacer(Modifier.height(100.px))

            val pageContext = rememberPageContext()
            // Full width, so the button's percentage width stays relative to the section as before
            Row(
                Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.Center,
                ref = rememberMotionRef { row -> revealOnScroll(row, y = 0.0, scale = 0.9, delay = 0.2, spring = true) }
            ) {
                CtaButton("Începe acum") {
                    AppTracking.logEvent(
                        AppTracking.EVENT_LANDING_CTA_CLICK,
                        mapOf(AppTracking.PARAM_CTA_LOCATION to AppTracking.CTA_LOCATION_BOTTOM)
                    )
                    pageContext.router.navigateTo("/quiz")
                }
            }
        }
    }
}

@Composable
private fun FooterSection() {
    Surface(
        Modifier
            .backgroundColor(AppTheme.colors.background)
            .fillMaxWidth()
            .then(landingSectionPaddingStyle.toModifier()),
        contentAlignment = Alignment.Center
    ) {
        Column(
            MaxWidthStyle.toModifier().fillMaxWidth()
        ) {
            FooterLogo(
                Modifier.displayUntil(Breakpoint.MD)
            )

            Spacer(
                Modifier.height(40.px)
                    .displayUntil(Breakpoint.MD)
            )

            Row(
                Modifier
                    .fillMaxWidth()
                    .displayUntil(Breakpoint.MD),
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                FooterLinks()
                FooterContact()
            }

            Row(
                Modifier.fillMaxWidth()
                    .displayIfAtLeast(Breakpoint.MD)
            ) {
                FooterLogo(
                )

                Spacer(Modifier.weight(1))

                FooterLinks()

                Spacer(Modifier.weight(0.5))

                FooterContact()
            }

            Spacer(Modifier.height(24.px))

            HorizontalDivider(
                MaxWidthStyle.toModifier()
                    .color(AppTheme.colors.textTertiary)
            )

            Spacer(Modifier.height(8.px))

            SpanText(
                "Copyright © 2024-2026 rezident.info",
                AppTheme.typography.body1.toModifier()
                    .color(AppTheme.colors.textTertiary)
            )
        }
    }
}

@Composable
private fun FooterLogo(
    modifier: Modifier = Modifier
) {
    Column(modifier.alignItems(AlignItems.Stretch)) {
        Row(
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            val colorMode = ColorMode.current
            Link(
                "#acasa",
                AppTheme.typography.body1.toModifier()
                    .color(AppTheme.colors.text)
            ) {
                Image(
                    if (colorMode.isLight) {
                        "logo-light.png"
                    } else {
                        "logo-dark.png"
                    },
                    Modifier.height(90.px)
                )
            }

            Link(
                "https://www.instagram.com/rezident.info/",
                AppTheme.typography.body1.toModifier()
                    .onClick { AppTracking.logEvent(AppTracking.EVENT_LANDING_INSTAGRAM_CLICK) }
            ) {
                FaInstagram(
                    Modifier.color(AppTheme.colors.textSecondary),
                    size = IconSize.X3
                )
            }
        }

        SpanText(
            "Descoperă-ți specialitatea la Rezi",
            AppTheme.typography.body1.toModifier()
                .color(AppTheme.colors.textTertiary)
        )
    }
}

@Composable
private fun FooterLinks() {
    Column {
        SpanText(
            "Link-uri rapide",
            AppTheme.typography.body1Medium.toModifier()
                .color(AppTheme.colors.text)
        )

        Spacer(innerPaddingStyle.toModifier())

        Link(
            "#acasa",
            "Acasă",
            AppTheme.typography.body1.toModifier()
                .color(AppTheme.colors.textSecondary)
        )

        Spacer(Modifier.height(16.px))

        Link(
            "#cum-functioneaza",
            "Cum funcționează?",
            AppTheme.typography.body1.toModifier()
                .color(AppTheme.colors.textSecondary)
        )

        Spacer(Modifier.height(16.px))

        Link(
            "#intrebari",
            "Întrebări frecvente",
            AppTheme.typography.body1.toModifier()
                .color(AppTheme.colors.textSecondary)
        )

        Spacer(Modifier.height(16.px))

        Link(
            "/contact",
            "Contactează-ne",
            AppTheme.typography.body1.toModifier()
                .color(AppTheme.colors.textSecondary)
        )

        Spacer(Modifier.height(16.px))

        Link(
            "/termeni",
            "Termeni și condiții",
            AppTheme.typography.body1.toModifier()
                .color(AppTheme.colors.textSecondary)
        )

        Spacer(Modifier.height(16.px))

        Link(
            "/confidentialitate",
            "Politica de confidențialitate",
            AppTheme.typography.body1.toModifier()
                .color(AppTheme.colors.textSecondary)
        )
    }
}

@Composable
private fun FooterContact() {
    Column {
        SpanText(
            "Contact",
            AppTheme.typography.body1Medium.toModifier()
                .color(AppTheme.colors.text)
        )

        Spacer(innerPaddingStyle.toModifier())

        Row(verticalAlignment = Alignment.CenterVertically) {
            FaInstagram(
                Modifier.color(AppTheme.colors.text),
                size = IconSize.XL,
            )

            Spacer(Modifier.width(8.px))

            Link(
                "https://www.instagram.com/rezident.info/",
                "rezident.info",
                AppTheme.typography.body1.toModifier()
                    .color(AppTheme.colors.textSecondary)
                    .onClick { AppTracking.logEvent(AppTracking.EVENT_LANDING_CONTACT_INSTAGRAM_CLICK) }
            )
        }

        Spacer(Modifier.height(16.px))

        Row(verticalAlignment = Alignment.CenterVertically) {
            FaEnvelope(
                Modifier.color(AppTheme.colors.text),
                size = IconSize.LG,
            )

            Spacer(Modifier.width(8.px))

            Link(
                "mailto:salut@rezident.info",
                "salut@rezident.info",
                AppTheme.typography.body1.toModifier()
                    .color(AppTheme.colors.textSecondary)
                    .onClick { AppTracking.logEvent(AppTracking.EVENT_LANDING_CONTACT_EMAIL_CLICK) }
            )
        }

        Spacer(Modifier.height(16.px))

        Link("https://reclamatiisal.anpc.ro/") {
            Image(
                src = "/anpc-sal.webp",
                alt = "Soluționarea Alternativă a Litigiilor (SAL)",
                modifier = Modifier.height(40.px)
            )
        }
    }
}

val buttonStyle = CssStyle {
    base {
        Modifier.width(60.percent)
    }

    Breakpoint.MD {
        Modifier.width(35.percent)
    }
}

@Composable
fun CtaButton(text: String, onClick: (SyntheticMouseEvent) -> Unit) {
    Button(
        onClick = onClick,
        buttonStyle.toModifier()
            .borderRadius(AppTheme.shapes.mediumRound)
            .setVariable(ButtonVars.BackgroundDefaultColor, AppTheme.colors.accent),
        size = ButtonSize.LG,
        colorPalette = AppTheme.colors.accentColorPalette,
        ref = rememberMotionRef { button -> attachSpringPress(button) }
    ) {
        SpanText(
            text,
            AppTheme.typography.body1Medium.toModifier()
                .color(AppTheme.colors.onAccent)
        )
    }
}

@Composable
private fun CoolLine() {
    Box(
        Modifier
            .width(150.px)
            .height(4.px)
            .backgroundColor(AppTheme.colors.icon)
            .borderRadius(AppTheme.shapes.bigRound)
            .styleModifier { property("transform-origin", "left center") },
        // Draws itself from left to right under the heading
        ref = rememberMotionRef { line ->
            playOnFirstView(
                line,
                prepare = { line.style.transform = "scaleX(0)" },
                play = {
                    animate(
                        line,
                        json("scaleX" to arrayOf(0, 1)),
                        json("duration" to 0.8, "delay" to 0.2, "ease" to RevealEase)
                    )
                }
            )
        }
    )
}

@Composable
private fun AutoScrollHandler() {
    val hash = window.location.hash
    LaunchedEffect(hash) {
        if (hash.isNotEmpty()) {
            val element = document.getElementById(hash.substring(1)) // Remove '#' and get element
            element?.scrollIntoView(js("{ behavior: 'smooth', block: 'start' }"))
        }
    }
}

// Animate arrow rotation (0° when collapsed, 180° when expanded)
val rotationAnimation = Keyframes {
    from {
        Modifier.rotate(0.deg)
    }

    to {
        Modifier.rotate(180.deg)
    }
}